import './cu_admission.css'

import { currencyConverter, formatDate, formatDateAndTime } from '../../../resources/constants';
import React from "react";

const HensardAdmissionLetter = (props) =>
{
    const app_det = props.data[0]?.admission?.app_det;
    const app_settings = props.data[0]?.admission?.app_settings[0];
    const admission_letter = props.data[0]?.admission?.admission_letter[0];
    const applicantInfo = props.data[0]?.admission?.applicant_details[0];
    const tuition_fee = props.data[0]?.tuition[0];
    return (
        <div>
            {
                props.data.length > 0 &&
                <div className="body"
                //      style={{
                //     backgroundImage: `url(${bgImage})`,
                //     backgroundRepeat: 'no-repeat',
                //     backgroundSize: 'cover',
                //     backgroundColor: 'transparent !important',
                //     paddingBottom: '10px'
                // }}
                     ref={props.ref}>
                    <div className="table-wrapper" style={{ marginLeft: "50px", marginRight: "50px", marginTop: "114px"}} >
                        <div>
                            <br />
                            <p className='p-text' style={{ fontSize:"13px"}} >
                                Application ID: APP/{app_det?.AdmissionSemester}/{app_det?.EntryID}
                                <br />
                                Approved Date: {formatDateAndTime(formatDate(app_det?.DecisionDate), "date")}
                                <br />
                                Applicant Name: {applicantInfo.FirstName} {applicantInfo.MiddleName} {applicantInfo.Surname}
                                <br />
                            </p>
                            <div>Dear {applicantInfo.FirstName},</div>
                        </div>
                        <div className="mb-2" style={{ fontWeight: "bolder", textAlign: "center" }}>OFFER OF PROVISIONAL ADMISSION</div>
                        <div style={{ marginTop: "-5px", fontSize:"13px" }} >
                            Following your application for admission to Hensard University, I am pleased to offer you a Provisional Admission into <b>{app_det?.DegreeInView}</b> in the <b>Faculty of {app_det?.FacultyName}, Department of {app_det?.DepartmentName}</b> level <b>{app_det?.DecisionLevel}</b> for the <b>{app_settings?.AcademicSession}.</b> Your academic journey commences <b>{formatDateAndTime(app_settings?.StartDate, "date")}</b>.<br/>
                            <div>This offer of admission is subject to fulfilling the following conditions:</div>
                            <div style={{ marginLeft: "30px", fontSize:"13px" }}>
                                    a. You must present your original credentials, including a minimum of 5 O'Level credits, which must include English Language, Mathematics, and other relevant subjects for your chosen field of study.<br/>
                                    b. You are required to pay the tuition fee of <b>{currencyConverter(parseInt(tuition_fee?.TuitionAmount))}</b> per semester, caution, and processing fee of 50,000 via the university’s online payment portal
                                        (<a href='https://portal.hensarduniversity.edu.ng/payment/' target={"_blank"}>portal.hensarduniversity.edu.ng/payment/</a>). Log in using your Application ID <strong>{app_det?.EntryID}</strong> and registered email <strong>{applicantInfo?.EmailAddress}</strong>.<br/>
                                    c.	You must log into the JAMB CAPS portal to upload your O’Level results and ensure that Hensard University is selected as your first-choice institution. Additionally, you are required to print and submit your JAMB Admission Letter upon resumption.<br/>
                                    d.	You must present yourself for physical screening at the university with the original and photocopies of all relevant documents. The physical screening of credentials will commence on <b>{formatDateAndTime(app_settings?.PhysicalScreeningStart, "date")}</b> and end on <b>{formatDateAndTime(app_settings?.PhysicalScreeningEnd, "date")}</b>.<br/>
                                    e.	Sign an undertaking to abide by all rules and regulations of Hensard University.<br/>
                                    f.	You are required to undergo a medical examination at a recognized government hospital to confirm your physical and mental fitness.<br/>
                                    g.	No changes to your name will be accepted after registration.<br/>
                                    h.	This admission offer is valid only for this academic session and cannot be deferred or transferred to another session.<br/>
                            </div>
                            <div>
                                Accommodation will be provided subject to availability. Kindly indicate your interest in securing on-campus accommodation at the time of registration. Failure to complete the required registration and payment within the stipulated period may lead to forfeiture of this admission
                            </div>
                            <br />
                            <div> Please accept our congratulations!</div>
                            <img src={require("./reg_sign.png")} style={{ width: "200px", height: '50px', marginTop: '10px' }} />
                            <br />
                            <div style={{ fontWeight: "bolder" }}>
                                Kebiru Umaru, PhD.
                            </div>
                            <p>Registrar</p>
                            <br />
                        </div>
                    </div>
                </div>
            }
        </div >
    )
}
export default HensardAdmissionLetter
